export default __webpack_public_path__ + "static/media/autograph-black.f473fcce.svg";